export default "__VITE_ASSET__CYsVDuSCCEM03O5h$WiJHw__";